export default __webpack_public_path__ + "static/media/image_6.4b264cc8.jpg";